import { openModalAttributes } from './open-modal.attributes';
import type { OpenModalData } from './open-modal.attributes';
import { richDetailsCloseFromWithinAttr } from './rich-details.attributes';
import { trackClickedAttributes } from './track-clicked.attributes';
import type { TrackClickedData } from './track-clicked.attributes';

export const clickActionsAttr = 'data-clk';

export type ClickActionsData = {
  closeRichDetailsFromWithin?: boolean;
  track?: TrackClickedData;
  modal?: OpenModalData;
};

export function clickActionsAttributes(data: ClickActionsData | undefined) {
  if (!data) return {};

  const attributes: Record<string, string | boolean> = {
    [clickActionsAttr]: '',
  };

  if (data.closeRichDetailsFromWithin) {
    attributes[richDetailsCloseFromWithinAttr] = true;
  }

  Object.assign(attributes, trackClickedAttributes(data.track));
  Object.assign(attributes, openModalAttributes(data.modal));

  return attributes;
}
